

import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

import IBSVGIconCircleCheckbox from "@/components/SVGIcon/IBSVGIconCircleCheckbox.vue";

@Component({
	components: {
		IBSVGIconCircleCheckbox
	}
})
export default class IBCircleCheckbox extends Vue {

	@Prop({ type: Boolean, default: false })
	readonly value!: boolean | null;

	@Prop({ type: Boolean, default: false })
	readonly disabled!: boolean;

	public active: boolean = false;

	public created() {
		this.active = this.value || false;
	}

	public toggleActive() {
		if (this.disabled) return;

		this.active = this.value === null
			? false
			: !this.active;
	}

	public updateActive(v: boolean) {
		if (v !== this.value) this.emitUpdateActive(v);
	}

	@Watch("active")
	protected activeOnChanged(v: boolean) {
		this.updateActive(v);
	}

	@Watch("value")
	protected activeModelOnChanged(v: boolean) {
		this.active = v;
	}

	@Emit("input")
	public emitUpdateActive(v: boolean): boolean {
		return v;
	}

}

